import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import PostCommunityCard from "../../../components/cards/PostCommunityCard";
import {
  useAdminLikeEmployeePostMutation,
  useAdminUnlikeEmployeePostMutation,
  useAdminCommentOnEmployeePostMutation,
  useAdminLikeEmployeeCommentMutation,
  useAdminUnlikeEmployeeCommentMutation,
} from "../../../services/organization/adminUsers";
import MyPostsStatisticsCard from "../../cards/MyPostsStatisticsCard";
import {
  useLazyAdminGetUserPostsQuery,
  useAdminGetUserPostStatsQuery,
} from "../../../services/organization/adminUsers";
import LoadingIndicator from "../../LoadingIndicator";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const Posts = ({ user }) => {
  const [allPosts, setAllPosts] = useState([]);
  const [page, setPage] = useState(1);
  const { t } = useTranslation(["common", "communityFeed"]);

  useEffect(() => {
    setPage(1);
    setAllPosts([]);
  }, [user?.id]);
  const [likePost] = useAdminLikeEmployeePostMutation();
  const [unlikePost] = useAdminUnlikeEmployeePostMutation();
  const [addComment] = useAdminCommentOnEmployeePostMutation();
  const [likeComment] = useAdminLikeEmployeeCommentMutation();
  const [unlikeComment] = useAdminUnlikeEmployeeCommentMutation();

  const { data: postStats } = useAdminGetUserPostStatsQuery(user?.id);
  const [listPosts, { data: posts, isLoading: isGetUserPostsLoading }] =
    useLazyAdminGetUserPostsQuery();

  useEffect(() => {
    if (user?.id) listPosts({ userId: user.id, page });
  }, [page, user?.id]);

  useEffect(() => {
    if (posts === undefined) return;
    const rows = posts.data ?? [];
    if (posts.pagination?.current === 1) {
      setAllPosts(rows);
    } else {
      setAllPosts((prev) => [...prev, ...rows]);
    }
  }, [posts]);

  const refetchFirstPage = async () => {
    if (!user?.id) return;
    await listPosts({ userId: user.id, page: 1 });
    setPage(1);
  };

  const handleToggleLike = async ({ postId, isLikedByMe }) => {
    try {
      if (isLikedByMe) {
        await unlikePost({ userId: user.id, postId }).unwrap();
      } else {
        await likePost({ userId: user.id, postId }).unwrap();
      }
      await refetchFirstPage();
    } catch (e) {
      toast.error(e?.data?.message || t("common:somethingWentWrong"));
    }
  };

  const handleSubmittingComment = async ({ postId, comment, setComment }) => {
    if (!comment?.trim()) return;
    try {
      await addComment({
        userId: user.id,
        postId,
        body: { body: comment },
      }).unwrap();
      setComment("");
      await refetchFirstPage();
    } catch (e) {
      toast.error(e?.data?.message || t("common:somethingWentWrong"));
    }
  };

  const handleToggleCommentLike = async (comment) => {
    try {
      if (comment.is_liked_by_me) {
        await unlikeComment({
          commentId: comment.id,
          userId: user.id,
        }).unwrap();
      } else {
        await likeComment({
          commentId: comment.id,
          userId: user.id,
        }).unwrap();
      }
      await refetchFirstPage();
    } catch (e) {
      toast.error(e?.data?.message || t("common:somethingWentWrong"));
    }
  };

  if (isGetUserPostsLoading) return <LoadingIndicator />;

  return (
    <div className="profile-about">
      <h1 className="font_20 font-extrabold mb-4">{t("allPosts")}</h1>

      <div className="row community-page g-3">
        <div className="col-12 col-lg-4 order-lg-2 mb-2 mb-lg-0">
          <MyPostsStatisticsCard
            title={t("communityFeed:interactions")}
            statistics={postStats?.data}
          />
        </div>
        <div className="col-12 col-lg-8 order-lg-1">
          {allPosts?.length > 0 ? (
            <ul>
              <InfiniteScroll
                className="feed-list"
                dataLength={allPosts.length}
                next={() => setPage(posts?.pagination?.next)}
                hasMore={posts?.pagination?.next}
                loader={<h4>{t("Loading")}</h4>}
                endMessage={
                  <p className="font-color-grey" style={{ textAlign: "center" }}>
                    <b>{t("communityFeed:successfulPostsDisplay")}</b>
                  </p>
                }
                style={{
                  overflow: "unset",
                }}
              >
                {allPosts.map((post) => {
                  return (
                    <li className="mb-3" key={post.id}>
                      <PostCommunityCard
                        post={post}
                        profileBasePath="/admin/employee"
                        handleToggleLike={handleToggleLike}
                        handleSubmittingComment={handleSubmittingComment}
                        onToggleCommentLike={handleToggleCommentLike}
                        handleDeletingPost={() =>
                          console.log("deleting postss")
                        }
                      />
                    </li>
                  );
                })}
              </InfiniteScroll>
            </ul>
          ) : (
            <p className="admin-employee-profile__empty-state">
              {t("communityFeed:noPostsYet")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Posts;
